import React,{ Suspense, lazy } from 'react'
import { createBrowserRouter } from 'react-router-dom'
import C from '../components/withAuthrization'

function authComponent(Component) {
  const WrappedComponent = C.withAuthrization(Component)
  return (
    <Suspense fallback={<div>loading...</div>}>
      <WrappedComponent />
    </Suspense>
  )
}

function purComponent(Component) {
  const WrappedComponent = C.withation(Component)
  return (
      <Suspense fallback={<div>loading...</div>}>
        <WrappedComponent />
      </Suspense>
  )
}
// 路由组件推荐使用懒加载的方式引入
const Home = purComponent(lazy(() => import('../pages/Home')))
const Login = purComponent(lazy(() => import('../pages/Login')))
const Thirdlogin = purComponent(lazy(() => import('../pages/Thirdlogin')))
const Register = purComponent(lazy(() => import('../pages/Register')))
const Country = purComponent(lazy(() => import('../pages/Country')))
const Map = purComponent(lazy(() => import('../pages/Map')))
const Notfound = purComponent(lazy(() => import('../pages/Notfound/notfound')))


const Persion = authComponent(lazy(() => import('../pages/Persion')))
const Dotlist = authComponent(lazy(() => import('../pages/Dotlist')))
const Order = authComponent(lazy(() => import('../pages/Order')))
const Scan = authComponent(lazy(() => import('../pages/Scan/scan')))
const Rent = authComponent(lazy(() => import('../pages/Rent')))
const User = authComponent(lazy(() => import('../pages/User')))
const Setting = authComponent(lazy(() => import('../pages/Setting/setting')))
const Privacy = authComponent(lazy(() => import('../pages/Privacy/privacy')))
const Histry = authComponent(lazy(() => import('../pages/Histry/histry')))
const Pay = authComponent(lazy(() => import('../pages/Pay/pay')))


const Wallet = authComponent(lazy(() => import('../pages/Wallet')))


const routes = [
  {
    path: '/', //path 对应 Route的path
    element: Home, //element 对应Route的element
    // children 对应 嵌套路由
    exact: true //精确匹配
  },
  {
    path: '/home', //path 对应 Route的path
    element: Home, //element 对应Route的element
    // children 对应 嵌套路由
    children: [
      {
        path: '/home/map',
        element: Map
      },
      {
        path: '/home/dotlist',
        element: Dotlist
      },
      {
        path: '/home/persion',
        element: Persion
      },
      {
        path: '/home/rent',
        element: Rent
      }
    ]
  },
  {
    path: '/thirlog',
    element: Thirdlogin
  },
  {
    path: '/scan',
    element: Scan
  },
  {
    path: '/login',
    element: Login
  },
  {
    path: '/country',
    element: Country
  },
  {
    path: '/register',
    element: Register
  },
  {
    path: '/order',
    element: Order
  },
  {
    path: '/wallet',
    element: Wallet
  },
  {
    path: '/user',
    element: User
  },
  {
    path: '/setting',
    element: Setting
  },
  {
    path: '/privacy',
    element: Privacy
  },
  {
    path: '/histry',
    element: Histry
  },
  {
    path: '/pay',
    element: Pay
  },
  {
    path: '*',
    element: Notfound,
  },

]

export default createBrowserRouter(routes)
